import React from 'react'
import { Helmet as HelmetImport, HelmetProps } from 'react-helmet';

const Helmet = HelmetImport as unknown as React.ComponentClass<HelmetProps>; // Temporary Types fixing

export const Seo = ({title, description = '', meta = []} : {title: string, description: string, meta: any[]}) => {
 return(
  <Helmet title = {title}
        //htmlAttributes={{ lang: "en" }}
        meta={meta}
   />
  )
}